/**
 * Function that clears the Local Storage
 */
const clearLocalStorage = () => {
    const localStorageItems = [
        'user',
        'permissionsReducer',
        'company_uuid',
        'account_uuid',
        'user_token',
        'APIRequestsCounter',
        'session',
        'branches',
        'selectedBranch',
        'userDetails',
        'user_token_expiry',
        'nylasAccountInfo',
        'language_profile_uuid',
        'employee_categories',
        'system_user',
    ];
    localStorageItems.forEach((item) => {
        localStorage.removeItem(item);
    });
}

// Export service
export const storageService = {
    clearLocalStorage,
};
